import { Eye, EyeOff } from "lucide-react";
import * as React from "react";

import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface PasswordInputProps extends Omit<
  React.ComponentProps<"input">,
  "type"
> {
  visible?: boolean;
  onVisibleChange?: (visible: boolean) => void;
}

function PasswordInput({
  className,
  visible,
  onVisibleChange,
  ...props
}: PasswordInputProps) {
  const [internalVisible, setInternalVisible] = React.useState(false);
  const show = visible ?? internalVisible;
  const setShow = onVisibleChange ?? setInternalVisible;

  return (
    <div className="relative">
      <Input
        type={show ? "text" : "password"}
        className={cn("pr-9", className)}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground"
        onClick={() => setShow(!show)}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}

export { PasswordInput };
